import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { FlowEdgeSpec, MaterialNodeSpec, OperationNodeSpec } from '@/graph/domain/types';
import { sectionBoxSx, labelValueRowSx, labelSx, valueSx } from './info.styles';

interface EdgeInfoProps {
  data: FlowEdgeSpec & { id: string };
  sourceLabel: string;
  sourceType: string;
  targetLabel: string;
  targetType: string;
}

export const EdgeInfo: React.FC<EdgeInfoProps> = ({
  data,
  sourceLabel,
  sourceType,
  targetLabel,
  targetType,
}) => {
  return (
    <Box>
      <Box sx={sectionBoxSx}>
        <Box sx={labelValueRowSx}>
          <Typography sx={labelSx}>From</Typography>
          <Typography sx={valueSx}>
            {sourceLabel} ({sourceType})
          </Typography>
        </Box>
        <Box sx={labelValueRowSx}>
          <Typography sx={labelSx}>To</Typography>
          <Typography sx={valueSx}>
            {targetLabel} ({targetType})
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
